/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Parking_CountInputs */

const cs_form_parking_count = /** @type {(inputs: Form_Parking_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Počet parkovacích míst`)
};

const en_form_parking_count = /** @type {(inputs: Form_Parking_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parking spaces`)
};

/**
* | output |
* | --- |
* | "Parking spaces" |
*
* @param {Form_Parking_CountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_parking_count = /** @type {((inputs?: Form_Parking_CountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Parking_CountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_parking_count(inputs)
	return cs_form_parking_count(inputs)
});